import type { LeadsBySourceItem } from "api/crm-analytics";
import { SourceBarChartCard } from "./SourceBarChartCard";

export const LeadsBySourceCard = ({
  data,
  isLoading,
  dateLabel
}: {
  data: LeadsBySourceItem[] | undefined;
  isLoading: boolean;
  dateLabel: string;
}) => (
  <SourceBarChartCard
    title="Leads by source"
    subtitle={`Lead volume by channel – ${dateLabel}`}
    data={data}
    isLoading={isLoading}
  />
);
